/* eslint-disable import/prefer-default-export */

const SIGN_IN_MODAL_SELECTOR = ".js-sign-in-modal";

const $getSignInModal = () => document.querySelector(SIGN_IN_MODAL_SELECTOR);

// Module-scoped storage for 2FA data — use getTwoFactorData() to access
let twoFactorData = {};

export const SignInModalUtils = {
  closeModal() {
    const $modalElement = $getSignInModal();
    if ($modalElement && $?.fn?.modal) {
      $($modalElement).modal("hide");
    }
  },

  createSignInButton(text = "Sign In") {
    return `<button
      type="button"
      data-testid="sign-in-toggle-button-from-error"
      data-sign-up-text="${text}"
      class="underline underline-offset-2 js-sign-in-modal-toggle"
    >
      ${text}
    </button>`;
  },

  replaceLoginLinkWithButton(errorMessage) {
    if (!errorMessage || typeof errorMessage !== "string") {
      return this.createSignInButton();
    }

    const signInLinkPattern = /<a[^>]*href=["']\/login["'][^>]*>([^<]+)<\/a>/gi;
    const replacedMessage = errorMessage.replace(signInLinkPattern, (_, linkText) => {
      const buttonText = linkText || "Sign In";
      return this.createSignInButton(buttonText);
    });

    return replacedMessage;
  },

  setGlobal2FAData(data, formAction) {
    twoFactorData = {
      authToken: data.authToken,
      rawPhoneNumber: data.rawPhoneNumber,
      phoneNumber: data.phoneNumber,
      email: data.email,
      smsEnabled: data.smsEnabled,
      emailEnabled: data.emailEnabled,
      redirectUrl: formAction || undefined
    };
  },

  /**
   * Returns a shallow copy of the module-scoped 2FA data.
   *
   * @returns {Record<string, unknown>} Copy of stored 2FA data
   */
  getTwoFactorData() {
    return { ...twoFactorData };
  },

  /**
   * Clears the module-scoped 2FA data and data attributes on the modal element
   * to reduce the token exposure window. Call after successful 2FA verification.
   */
  clearTwoFactorData() {
    twoFactorData = {};

    // Clear data attributes on the modal element to reduce token exposure window.
    // selectedChannel is cleared so subsequent 2FA sessions re-derive the default
    // channel from current capabilities.
    // listenersInitialized is intentionally NOT cleared: the event listeners are
    // bound to the DOM element, so clearing the flag on the same element would
    // cause initTwoFactorModal() to register duplicate handlers (verify, resend,
    // alt-channel) the next time it is called, resulting in double API calls.
    // If the modal element is replaced entirely in the DOM, listenersInitialized
    // on the old node is irrelevant and the new node starts without the flag anyway.
    const verificationModal = document.getElementById("verification-code-modal");
    if (verificationModal) {
      delete verificationModal.dataset.authToken;
      delete verificationModal.dataset.rawPhoneNumber;
      delete verificationModal.dataset.redactedPhone;
      delete verificationModal.dataset.redactedEmail;
      delete verificationModal.dataset.smsEnabled;
      delete verificationModal.dataset.emailEnabled;
      delete verificationModal.dataset.redirectUrl;
      delete verificationModal.dataset.selectedChannel;
    }
  },

  handleTwoFactorAuth(data, formElement, modalElement) {
    this.setGlobal2FAData(data, formElement.getAttribute("data-redirect-url"));

    // Bridge the AJAX flow: set data attributes on the modal container so
    // initTwoFactorModal() can read them (same pattern as the HTML flow)
    const verificationModal = document.getElementById("verification-code-modal");
    if (verificationModal) {
      verificationModal.dataset.authToken = data.authToken || "";
      verificationModal.dataset.rawPhoneNumber = data.rawPhoneNumber || "";
      verificationModal.dataset.redactedPhone = data.phoneNumber || "";
      verificationModal.dataset.redactedEmail = data.email || "";
      verificationModal.dataset.smsEnabled = String(!!data.smsEnabled);
      verificationModal.dataset.emailEnabled = String(!!data.emailEnabled);
      verificationModal.dataset.redirectUrl = formElement.getAttribute("data-redirect-url") || "";
    }

    $(modalElement).modal("hide");
    window.initTwoFactorModal();
  }
};
